module.exports = __webpack_public_path__ + "static/media/goalie.c7eba962.jpg";